import render from '@/filters/render'

export default {
  filters: { render },

  methods: {
    /**
     * Easily pass the render function to the template. To overide the
     * variable source, ensure a "ctx" property exists - Fallsback to "_self".
     */
    render(string) {
      return this.$options.filters.render(string, this.ctx || this._self)
    },
  },
}
